const { http, HttpResponse } = window.MockServiceWorker;
import { umbTemplateMockDb } from '../../db/template.db.js';
import { UMB_SLUG } from './slug.js';
import { umbracoPath } from '@umbraco-cms/backoffice/utils';

export const itemHandlers = [
	http.get(umbracoPath(`/item${UMB_SLUG}/search`), ({ request }) => {
		const url = new URL(request.url);
		const query = url.searchParams.get('query') ?? '';
		const skip = Number(url.searchParams.get('skip')) || 0;
		const take = Number(url.searchParams.get('take')) || 100;

		const response = umbTemplateMockDb.item.search(query, skip, take);

		return HttpResponse.json(response);
	}),

	http.get(umbracoPath(`/item${UMB_SLUG}`), ({ request }) => {
		const ids = new URL(request.url).searchParams.getAll('id');
		if (!ids.length) return;
		const items = umbTemplateMockDb.item.getItems(ids);
		return HttpResponse.json(items);
	}),
];
